import React, { useContext, useMemo } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';

import { AuthContext } from '../contexts/authContext';
import { useSelectedCarrier } from '../hooks/apiHooks';
import Layout from '../layout';
import { UserRole } from '../models/User';

const AdminCarrierLayoutWrapper = ({ adminSubRoutes, carrierSubRoutes, routes }) => {
  const { pathname } = useLocation();
  const { authUser } = useContext(AuthContext);
  const { selectedCarrier } = useSelectedCarrier();

  const isAdmin = useMemo(
    () => authUser && [UserRole.SUPER_ADMIN, UserRole.ADMIN].includes(authUser.role),
    [authUser]
  );

  const isOnCarrierRoute = /^\/carrier\/[^/]/.test(pathname);
  const menuIndex = isAdmin && isOnCarrierRoute ? 1 : 0;

  const isViewRates = pathname === '/' || pathname === '' || /^\/carrier\/[^/]+\/?$/.test(pathname);
  const isAuditRates = pathname === '/audit' || /^\/carrier\/[^/]+\/audit\/?$/.test(pathname);
  const isUploadRates = pathname === '/upload';
  const isCostPerKm = /^\/carrier\/[^/]+\/cost-per-km$/.test(pathname);
  const skipFullPageLoader = isViewRates || isAuditRates || isUploadRates || isCostPerKm;

  const carrierLoading = isOnCarrierRoute && !selectedCarrier;

  const allRoutes = [...adminSubRoutes, ...carrierSubRoutes];

  return (
    <Layout
      disableLoading
      carrierLoading={carrierLoading}
      menuIndex={menuIndex}
      routes={routes}
      showCarriersNavigation={isAdmin}
      skipFullPageLoader={skipFullPageLoader}
    >
      <Switch>
        {allRoutes.map((route) => (
          <Route
            key={route.path}
            exact={route.exact}
            path={route.path}
            render={() => <route.component disableLayout routes={routes} />}
          />
        ))}
      </Switch>
    </Layout>
  );
};

export default AdminCarrierLayoutWrapper;
